import { IconProp } from "@fortawesome/fontawesome-svg-core"
import clsx from "clsx"

import convertToKebabCase from "@utils/convertToKebabCase"
import { faIcon } from "@utils/faIcon"

import { Icon } from "@atoms"

import { Table } from "@organisms"

import styles from "./DownPaymentCell.module.scss"
import { DownPaymentCellProps, DownPaymentStatus } from "./DownPaymentCell.types"

export default function DownPaymentCell(props: DownPaymentCellProps) {
    const { value } = props

    if (!value) {
        return <Table.Cells.NoValueCell />
    }

    const iconMap: {
        [key in DownPaymentStatus]: IconProp
    } = {
        "Not Required": faIcon({ name: "minus", style: "regular" }),
        Paid: faIcon({ name: "circle-check", style: "regular" }),
        "Partially Paid": faIcon({ name: "circle-half-stroke", style: "regular" }),
        Unpaid: faIcon({ name: "circle-xmark", style: "regular" }),
    }

    return (
        <div className={clsx(styles.base, styles[convertToKebabCase(value)])}>
            <Icon icon={iconMap[value]} size={12} container="fixedHeight" />
            {value}
        </div>
    )
}
